// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iF1Q","content":"styles_content__1MVPP","row":"styles_row__24WEI","footer":"styles_footer__1ll-O","phraseLength":"styles_phraseLength__1yyHA"};